export default __webpack_public_path__ + "static/ai-solutions-with-roadmap4-6f8af2196eb984f71105385bda512801.webp";